import gql from "graphql-tag";
import Context from "shared/util/Context";
import getApolloClient from "shared/util/getApolloClient";

const LIKES_INCOMING_QUERY = gql`
	query likesIncomingCount($userid: String!) {
		user(id: $userid) {
			id
			notificationCounts {
				likesIncoming
			}
		}
	}
`;

export function decrementIncomingLikesCount() {
	const client = getApolloClient();
	const currentUserId = Context.get("userid");

	const data = client.readQuery({
		query: LIKES_INCOMING_QUERY,
		variables: { userid: currentUserId },
	});

	const likesIncomingCount = data.user?.notificationCounts?.likesIncoming || 0;

	if (!likesIncomingCount) return;

	client.writeQuery({
		query: LIKES_INCOMING_QUERY,
		variables: { userid: currentUserId },
		data: {
			...data,
			user: {
				...data.user,
				notificationCounts: {
					...data.user.notificationCounts,
					likesIncoming: likesIncomingCount - 1,
				},
			},
		},
	});
}



// WEBPACK FOOTER //
// ./src/shared/notifications/decrementIncomingLikesCount.js